<template>
  <el-alert
    v-if="confirmation && confirmed === null"
    class="loginView__left-confirmation"
    :title="$t('auth.login.view.confirmationInProgress')"
    type="neutral"
  />
  <el-alert
    v-else-if="confirmation && !confirmed"
    class="loginView__left-confirmation"
    :title="$t('auth.login.view.failedConfirmation')"
    type="error"
  />
  <el-alert
    v-else-if="confirmation && confirmed"
    class="loginView__left-confirmation"
    :title="$t('auth.login.view.accountConfirmed')"
    type="success"
  />
</template>

<script>
export default {
  name: "AccountConfirmation",
  data: () => ({
    confirmed: null
  }),
  computed: {
    confirmation() {
      return this.$route.query.confirmation
    }
  },
  async mounted() {
    if (this.confirmation) {
      try {
        await this.$store.dispatch('customer/confirm', {
          token: this.confirmation
        })

        this.confirmed = true
      } catch (error) {
        console.log(error)
        this.confirmed = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>